<template>
  <v-container
    id="worlds-list"
    tag="section"
  >
    <!-- Toast de réussite ou d'échec -->
    <!--<v-snackbar
      v-model="msg.alert"
      top
      shaped
      :color="msg.type"
      :timeout="msg.timeout"
    >
      <v-icon left>
        {{ msg.icon }}
      </v-icon>
      {{ msg.msg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="msg.alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>-->
    <v-row justify="center">
      <v-col cols="8">
        <timed-alert
          :display="msg.alert"
          :msg="msg.msg"
          :type="msg.type"
        />
      </v-col>
    </v-row>

    <base-material-card
      color="primary"
      icon="mdi-earth"
      inline
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <div class="display-2 font-weight-light">
          <v-icon left>
            mdi-earth
          </v-icon>
          {{ title }}
        </div>
      </template>

      <!-- **************** ***
      ****      MODALS      ***
      **** **************** -->
      <!-- Modal de création de monde -->
      <template v-slot:after-heading>
        <v-dialog
          v-model="addDialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              outlined
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Ajouter un monde
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline secondary--text">Nouveau monde</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <!-- Formulaire -->
                <v-form
                  ref="addForm"
                  v-model="addIsValid"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="addedItem.title"
                        :rules="[rules.required]"
                        label="Nom..."
                        counter="150"
                        prepend-icon="mdi-earth"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="addedItem.thematicId"
                        :items="thematics"
                        item-value="id"
                        item-text="title"
                        :rules="[rules.required]"
                        label="Thématique associée..."
                        prepend-icon="mdi-chat-processing-outline"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="addedItem.smilesNeededToUnlockByDefault"
                        type="number"
                        :rules="[rules.required]"
                        label="Nombre de sourire requis..."
                        prepend-icon="mdi-emoticon-excited-outline"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="success darken-1"
                text
                :disabled="!addIsValid"
                @click="addItem()"
              >
                Créer
              </v-btn>
              <v-btn
                color="error darken-1"
                text
                @click="addDialog = false"
              >
                Annuler
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- Modal de modification de monde -->
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="headline secondary--text">Modification du monde<br><b>{{ editedItem.title }}</b></span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <!-- Formulaire -->
              <v-form
                ref="editForm"
                v-model="editIsValid"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.title"
                      :rules="[rules.required]"
                      label="Nom..."
                      counter="150"
                      prepend-icon="mdi-earth"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="editedItem.thematicId"
                      :items="thematics"
                      item-value="id"
                      item-text="title"
                      :rules="[rules.required]"
                      label="Thématique associée..."
                      prepend-icon="mdi-chat-processing-outline"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.smilesNeededToUnlockByDefault"
                      type="number"
                      :rules="[rules.required]"
                      label="Nombre de sourire requis..."
                      prepend-icon="mdi-emoticon-excited-outline"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              :disabled="!editIsValid"
              @click="editItem()"
            >
              Modifier
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="editDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de suppression de monde -->
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title class="headline">
            Êtes-vous sûr de vouloir<br>supprimer cet élément ?
          </v-card-title>
          <v-card-text>
            <!-- Récapitulatif des informations -->
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="deletedItem.title"
                  label="Nom..."
                  prepend-icon="mdi-earth"
                  readonly
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="deletedItem.id"
                  label="Identifiant..."
                  prepend-icon="mdi-card-account-details"
                  readonly
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="deletedItem.thematicId"
                  label="Thématique..."
                  prepend-icon="mdi-chat-processing-outline"
                  readonly
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="deletedItem.smilesNeededToUnlockByDefault"
                  label="Sourires..."
                  prepend-icon="mdi-emoticon-excited-outline"
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              @click="deleteItem()"
            >
              Supprimer
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="deleteDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- **************** ***
      ****      TABLE      ***
      **** **************** -->
      <!-- Champ de recherche dans la table -->
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Rechercher"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['id']"
        :sort-desc="[false]"
        :loading="isLoading"
        multi-sort
      >
        <!-- Centrage des header d'actions -->
        <!-- <template v-slot:header.ressources="{ header }">
          <v-row justify="center">
            {{ header.text }}
          </v-row>
        </template>
        <template v-slot:header.edit="{ header }">
          <v-row justify="center">
            {{ header.text }}
          </v-row>
        </template>
        <template v-slot:header.delete="{ header }">
          <v-row justify="center">
            {{ header.text }}
          </v-row>
        </template> -->

        <!-- Comportement particulier des logos avec construction de l'url -->
        <template v-slot:item.ressources="{ item }">
          <v-row justify="center">
            <v-icon
              class="info--text"
              @click="routeToWorldResources(item)"
            >
              mdi-book-open-page-variant
            </v-icon>
          </v-row>
        </template>

        <!-- Trésors -->
        <template v-slot:item.treasures="{ item }">
          <v-row justify="center">
            <v-icon
              class="info--text"
              @click="routeToWorldTreasures(item)"
            >
              mdi-treasure-chest
            </v-icon>
          </v-row>
        </template>

        <!-- Jeux -->
        <template v-slot:item.games="{ item }">
          <v-row justify="center">
            <v-icon
              class="info--text"
              @click="routeToWorldGames(item)"
            >
              mdi-gamepad-square
            </v-icon>
          </v-row>
        </template>

        <!-- Définition de l'action d'édition -->
        <template v-slot:item.edit="{ item }">
          <v-row justify="center">
            <v-icon
              class="success--text"
              @click="prepareEditItem(item)"
            >
              mdi-pencil
            </v-icon>
          </v-row>
        </template>

        <!-- Définition de l'action de suppression -->
        <template v-slot:item.delete="{ item }">
          <v-row justify="center">
            <v-icon
              class="error--text"
              @click="prepareDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import TimedAlert from '../alerts/TimedAlert.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'WorldsList',

    /* Sous-composants utilisés par ce composant */
    components: {
      TimedAlert,
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: () => ({
      title: 'Mondes',
      isLoading: true,

      // Variables pour les formulaires de création / modification / suppression
      thematics: [],
      rules: {
        required: value => !!value || 'Ce champ est obligatoire.',
      },

      addDialog: false,
      addIsValid: true,
      addedItem: {
        title: undefined,
        smilesNeededToUnlockByDefault: undefined,
        thematicId: undefined,
      },

      editDialog: false,
      editIsValid: true,
      editedItem: {
        id: undefined,
        name: undefined,
        companyCode: undefined,
        endOfAccessAt: undefined,
      },

      deleteDialog: false,
      deletedItem: {
        id: undefined,
        name: undefined,
        companyCode: undefined,
        endOfAccessAt: undefined,
        picture: undefined,
        worlds: undefined,
      },

      // Message de réussite ou d'échec des actions
      msg: {
        alert: false,
        msg: '',
        timeout: 5000,
        type: 'success',
      },

      // Variables relatives au tableau de données
      headers: [
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Nom',
          value: 'title',
        },
        {
          text: 'Nombre de sourires',
          value: 'smilesNeededToUnlockByDefault',
        },
        {
          text: 'Thématique',
          value: 'thematicId',
        },
        {
          sortable: false,
          text: 'Ressources',
          value: 'ressources',
        },
        {
          sortable: false,
          text: 'Trésors',
          value: 'treasures',
        },
        {
          sortable: false,
          text: 'Jeux',
          value: 'games',
        },
        {
          sortable: false,
          text: 'Éditer',
          value: 'edit',
        },
        {
          sortable: false,
          text: 'Supprimer',
          value: 'delete',
        },
      ],
      items: [],
      search: undefined,
    }),

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchWorlds()
      this.fetchThematics()
    },

    /* Fonctions internes */
    methods: {
      // Route l'application vers la liste des ressources pour un monde
      routeToWorldResources: function (item) {
        this.$router.push({
          name: 'World Resources List',
          params: {
            idWorld: item.id.toString(),
            nameWorld: item.title,
          },
        })
      },

      // Route l'application vers la liste des trésors pour un monde
      routeToWorldTreasures: function (item) {
        this.$router.push({
          name: 'World Treasures List',
          params: {
            idWorld: item.id.toString(),
            nameWorld: item.title,
          },
        })
      },

      // Route l'application vers la liste des jeux pour un monde
      routeToWorldGames: function (item) {
        this.$router.push({
          name: 'World Games List',
          params: {
            idWorld: item.id.toString(),
            nameWorld: item.title,
          },
        })
      },

      // Récuperation de tous les mondes
      fetchWorlds: function () {
        this.isLoading = true
        this.$Auth.httpRequest('get', 'api/world/selectAll')
          .then(datas => {
            if (Array.isArray(datas.data) || datas.data.length > 0) {
              this.items = datas.data
            } else {
              this.items = []
            }
          })
          .catch((/* error */) => {
            this.items = []
            /* if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            } */
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Récuperation de toutes les thématiques
      fetchThematics: function () {
        this.$Auth.httpRequest('get', 'api/thematic/selectAll')
          .then(datas => {
            if (Array.isArray(datas.data) || datas.data.length > 0) {
              this.thematics = datas.data
            } else {
              this.thematics = []
            }
          })
          .catch((/* error */) => {
            this.thematics = []
            /* if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            } */
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      /* ********************************* **
      /** Fonctions relatives aux messages **
      /** ******************************** */
      /* Setter de message de réussite */
      setMsgSuccess: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'success'
        this.msg.icon = 'mdi-checkbox-marked-circle-outline'
      },

      /* Setter de message d'échec */
      setMsgError: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'error'
        this.msg.icon = 'mdi-error-outline'
      },

      /* *************************** **
      /** Fonctions d'ajout de monde **
      /** ************************** */
      addItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.addDialog = false
        this.msg.alert = false

        // Ajout d'un monde
        this.$Auth.httpRequest('post', 'api/world/insert', {
          title: this.addedItem.title,
          thematicId: this.addedItem.thematicId,
          smilesNeededToUnlockByDefault: this.addedItem.smilesNeededToUnlockByDefault,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le monde a été créé avec succès.')

            // Réinitialisation des valeurs pour l'item ajouté
            this.addedItem.title = undefined
            this.addedItem.thematicId = undefined
            this.addedItem.smilesNeededToUnlockByDefault = undefined
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la création du monde.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.addForm.resetValidation()
            this.isLoading = false
            this.fetchWorlds()
          })
      },

      /* *********************************** **
      /** Fonctions de modification de monde **
      /** ********************************** */
      prepareEditItem: function (item) {
        // Création du clone d'item
        this.editedItem = { ...item }
        this.editDialog = true
      },

      editItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.editDialog = false
        this.msg.alert = false

        // Modification du monde
        this.$Auth.httpRequest('post', 'api/world/update', {
          id: this.editedItem.id,
          title: this.editedItem.title,
          thematicId: this.editedItem.thematicId,
          smilesNeededToUnlockByDefault: this.editedItem.smilesNeededToUnlockByDefault,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le monde a été modifié avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la modification du monde.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.editForm.reset()
            this.isLoading = false
            this.fetchWorlds()
          })
      },

      /* ********************************** **
      /** Fonctions de suppression de monde **
      /** ********************************* */
      prepareDeleteItem: function (item) {
        // Création du clone d'item
        this.deletedItem = { ...item }
        this.deleteDialog = true
      },

      deleteItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.deleteDialog = false
        this.msg.alert = false

        //  Suppression d'un monde
        this.$Auth.httpRequest('delete', 'api/world/delete?id=' + this.deletedItem.id)
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le monde a été supprimé avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la suppression du monde.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
            this.fetchWorlds()
          })
      },
    },
  }
</script>
